<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'协同管理'},{title:'协同部门配置'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                          <el-form-item label="供应商名称" >
                            <el-input v-model="q.supplierName" placeholder="请输入名称/编码" :clearable="true"></el-input>
                          </el-form-item>
                          <el-form-item label="省份">
                            <el-select filterable v-model="q.provincesName" clearable placeholder="请选择"
                            >
                              <el-option
                                  v-for="(item,index) in areaList"
                                  :key="item.name"
                                  :label="item.name"
                                  :value="item.name">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="状态">
                            <el-select v-model="q.status" placeholder="请选择">
                              <el-option label="冻结" value="0"></el-option>
                              <el-option label="正常" value="1"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      <div class="l-screenBox">
                        <div class="l-retrieval">
                          <el-form-item>
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="adduser">新增
                            </el-button>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
                              max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="supplierCode"
                                label="供应商编码"
                                  width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="supplierName"
                                :show-overflow-tooltip="true"
                                width="180"
                                label="供应商名称">
                        </el-table-column>
                        <el-table-column
                                prop="provincesName"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="省">
                        </el-table-column>
                        <el-table-column
                                prop="cityName"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="市">
                        </el-table-column>
                        <el-table-column
                                prop="regionName"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="区">
                        </el-table-column>
                      <el-table-column
                          prop="status"
                          :show-overflow-tooltip="true"
                          width="100"
                          label="状态">
                        <template slot-scope="scope">
                          <div v-if="scope.row.status=='1'">正常</div>
                          <div v-if="scope.row.status=='0'" >冻结</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="freezeUserName"
                          label="冻结人"
                          width="120">
                      </el-table-column>
                      <el-table-column
                          prop="freezeDate"
                          label="冻结时间"
                          width="120">
                      </el-table-column>
                      <el-table-column
                              fixed="right"
                              label="操作"
                              width="70">
                          <template slot-scope="scope">
                              <div class="w-caozuo" style="text-align: left;">
                                  <el-button
                                          type="text"
                                          size="small"
                                          class="h-tableLink h-btn" @click="update(scope.row)">
                                      修改
                                  </el-button>
                              </div>
                          </template>
                      </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                                       icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ"  @click="freezeList" v-if="">批量冻结</el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ"  @click="thawList" v-if="">批量解冻</el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="bscSupplierAreaCompareExcel"
                                    :startrow="2"
                                    :extparams="q"
                                    @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell" v-if="this.saveorupdate==1">
                            <h1>新增信息</h1>
                            <p>New</p>
                        </div>
                        <div class="h-tableCell" v-if="this.saveorupdate==2">
                            <h1>修改信息</h1>
                            <p>Update</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="f" :rules="rules" ref="f"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                      <el-form-item label="供应商名称" class="h-elformWrap-2" prop="supplierName">
                        <el-select v-model="f.supplierName" remote filterable :filter-method="getSupplier" clearable
                                   placeholder="请输入"
                                   :remote-method="getSupplier" @change="getSupplier">
                          <el-option v-for="(item) in supplierList"
                                     :key="item.username"
                                     :label="item.username"
                                     :value="item.username">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="供应商编码" class="h-elformWrap-2" prop="areaCode">
                        <el-input  :v="f.supplierCode" v-model="f.supplierCode" :clearable="true" disabled
                        />
                      </el-form-item>
                      <el-form-item label="选择地址"
                                    readonly
                                    :rules="[{ required: true, message: '请输入选择地址', trigger:['change', ' blur','input']}]"
                                    prop="toAddress" class="h-elformWrap-2">
                        <el-input clearable v-model="f.areaName" readonly style="width:100%;">
                          <i
                              class="el-icon-search el-input__icon"
                              slot="suffix"
                              @click="selectAreadialog">
                          </i>
                        </el-input>
                      </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert">提交
                    </el-button>
                </div>
            </el-dialog>
          <!--地址信息-->
          <areaSelectNotDetails
              :visible.sync="showdizhiflag"
              v-if="showdizhiflag"
              @choseObj="choseDizhi"
          />
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import supplierAreaService from "../../../api/dingd/supplierArea"

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                //表格
                multipleSelection: [],
                canjobpoint:true,
                isImport:false,
                //导入Excel
                uploaddownexcelflag: false,
                showdizhiflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                areaList:[],
                channelList:[],
                //临时的id
                iditem:'',
                userInfo: {
                    usercode: null,
                    username: null,
                },
                //分页/检索
                q: {
                    jobGroup:null,
                    jobUsercode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                },
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                supplierList:[],
                //弹窗
                dialogFormVisible: false,
              rules: {
                supplierName:[{required: true, message: '供应商名称必填', trigger:['change', ' blur','input']}],
                supplierCode:[{required: true, message: '供应商编码必填', trigger: 'change'}],
              },
            }
        },
        created() {
            this.query();
            this.channelList = this.$store.getters.dictlist("sales_region");
            this.areaList = this.$store.getters.dictlist("target_area");
            this.isImport = this.$store.getters.hasRole('swyl_admin,swyl_shfw');
        },
        methods: {
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.customerCode = null;
                this.q.area = null;
                this.q.channel = null;
                this.q.user = null;
            },
            query() {
                ss.supplierAreaService.selectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            adduser() {
                this.saveorupdate = 1
                this.f.id = null;
                this.f.supplierName = null;
                this.f.supplierCode = null;
                this.f.areaName = null;
                this.dialogFormVisible = true;
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.id = null;
                this.f.supplierName = null;
                this.f.supplierCode = null;
                this.f.areaName = null;
                this.$refs[formName].resetFields();
            },
            //新增
            insert() {
                ss.supplierAreaService.updateById(this.f).then(rd => {
                    this.query();
                    this.$msg.msgs(rd.msg);
                    this.dialogFormVisible = false;
                })
            },
            //勾选事件
            handleSelectionChange(val) {
              this.multipleSelection = val;
              var sum = 0;
              this.multipleSelection.forEach(element => {
                element.syNum = element.availableNum - element.proNumber;
                sum += element.includeTaxAmount;
              });
              //进行强制数据渲染
              this.$forceUpdate();
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.xietongguanli.deleteDept(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
            //修改
            update(value) {
              this.saveorupdate = 2;
                ss.supplierAreaService.selectById(value.id).then(rd => {
                    console.log(rd,"rdrdrdrdrdrdrd");
                    this.dialogFormVisible = true;
                    this.f = rd.obj;
                })
            },
            //根据用户编码获取用户信息
            getUserName(){
                var usercode = this.f.jobUsercode;
                ss.UserService.selectById(usercode).then(rd => {
                    console.log("getUserName",rd)
                    this.f={
                        id:this.iditem,
                        jobUsercode:rd.obj.usercode,
                        jobUsername:rd.obj.username,
                        jobGroup:this.f.jobGroup,
                    }
                    console.log("getUserName123",rd)
                })
            },
            deleteSelete() {
              var idlist = [];
              this.multipleSelection.forEach(element => {
                idlist.push(element.id);
              });
              console.log(idlist)
              this.deleteSingle(idlist)
            },
            deleteSingle(id) {
              console.log("id", id)
              var data = id
              this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                ss.supplierAreaService.deleteList(data).then(res => {
                  console.log(res)
                  if (res.f == true) {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    this.query()
                  } else {
                    this.$message.error(res.msg);
                  }
                })

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });

            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/demo/bscSupplierRegionCompare/downloadExcel", this.q, "get",);
            },
            //选择地址
            selectAreadialog() {
              this.showdizhiflag = true;
            },
            choseDizhi(obj) {
              console.log("obj",obj);
              this.f.areaName = obj.quobj.namepath;
              this.f.areaId = obj.quobj.code;
              this.showdizhiflag = false;
            },
            getSupplier(value){
                ss.supplierAreaService.selectByUserName(value).then(res => {
                  console.log(res)
                  this.supplierList = res.obj
                  this.f.supplierName = res.obj[0].username
                  this.f.supplierCode = res.obj[0].usercode
                })
            },
          freezeList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            console.log(this.multipleSelection);
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.supplierCode = this.multipleSelection[i].supplierCode;
              query.push(querys);
            }
            console.log(query);
            ss.supplierAreaService.freezeList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("冻结成功！")
                this.query();
              }
            });
          },
          thawList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.freezeUser = this.multipleSelection[i].freezeUser;
              querys.supplierCode = this.multipleSelection[i].supplierCode;
              query.push(querys);
            }
            console.log(query);
            ss.supplierAreaService.thawList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("解冻成功！")
                this.query();
              }
            });
          },
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .el-table tbody td:last-child{
        border-left: 1px solid #c2d2db;
    }
</style>
